exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".flash-yellow{-webkit-animation-name:flash-animation;-webkit-animation-duration:1s;animation-name:flash-animation;animation-duration:1s}@keyframes flash-animation{0%{background:#ffff9c}to{background:none}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/less/flashYellow.less
 ** module id = 1089
 ** module chunks = 0
 **/